/**
 * Constantes pour le portail
 */
export const HuitabConstantes = {
  SIREN_ALL: 'all',
};
